import * as React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  Chip,
  CircularProgress,
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { addSuperAdmin, updateSuperAdmin } from '../../api/superadmin/superadmin';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  roleId: '',
  roleName: '',
  contactNo: '',
  city: '',
  state: '',
  country: '',
  zip: '',
};

export default function SuperAdminDialog({
  dialogOpen,
  setDialogOpen,
  setDialogOpen1,
  selectedItem,
  action,
  setSnackbarMessage,
  setSnackbarOpen,
  setAdminManager
}) {
  const { commonData } = useSelector((state) => state.adminUser)

  const theme = useTheme();
  const [inputs, setInputs] = useState(initialState);
  const [tempInputs, setTempInputs] = useState();
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const { data } = action === 'CREATE' ? await addSuperAdmin(inputs) : await updateSuperAdmin(selectedItem._id, inputs)
      if (data.success) {
        // console.log({ data });
        setAdminManager(data.superAdmins)
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: true });
        setSnackbarOpen(true);
        setDialogOpen(false);

      } else {
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setIsLoading(false);
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  };

  const handleSelect = (event) => {
    console.log(event.target.value);
    // setRole(event.target.value);
    setInputs({ ...inputs, roleId: event.target.value })
  };

  const handleClose = () => {
    setDialogOpen(false);
  };
  const handleSkip = () => {
    setDialogOpen(false);
    setDialogOpen1(true);
  };
  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
    setTempInputs({ ...tempInputs, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    // console.log('in hook', action);
    if (action !== 'CREATE') {
      console.log('am in', selectedItem);
      setInputs({
        firstName: selectedItem.firstName,
        lastName: selectedItem.lastName,
        email: selectedItem.email,
        roleId: selectedItem.roleId,
        roleName: selectedItem.role,
        contactNo: selectedItem.contactNo,
        city: selectedItem.city,
      })
    }
    else {
      setInputs(initialState);
    }
  }, [dialogOpen])

  return (
    <Box>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>{action === 'CREATE' ? "Create" : "Edit"} Super Admin</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>

            <TextField
              required
              autofocus
              margin="dense"
              name="firstName"
              label="First Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.firstName}
              onChange={handleInputChange}
            />

            <TextField
              required

              margin="dense"
              name="lastName"
              label="Last Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.lastName}
              onChange={handleInputChange}
            />

            <TextField
              required
              margin="dense"
              name="email"
              label="Email"
              type="email"
              fullWidth
              variant="standard"
              value={inputs.email}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="contactNo"
              label="Phone"
              fullWidth
              variant="standard"
              inputProps={{ maxLength: 10 }}
              value={inputs.contactNo}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="city"
              label="City"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.city}
              onChange={handleInputChange}
            />
            {/* <TextField
              margin="dense"
              name="state"
              label="State"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.state}
              onChange={handleInputChange}
            />
            <TextField
              margin="dense"
              name="country"
              label="Phone"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.country}
              onChange={handleInputChange}
            />
            <TextField
              margin="dense"
              name="zip"
              label="Zip Code"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.zip}
              onChange={handleInputChange}
            /> */}
            <FormControl variant="standard" sx={{ minWidth: 350 }}>
              <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>
              <Select
                required
                labelId="demo-simple-select-standard-label"
                value={inputs.roleId}
                onChange={handleSelect}
                label="Role"
              >
                {commonData.superAdminRoles.map((item) => (
                  item.superAdminRoleId !== '64a3b2ba6e16c52119774847' && <MenuItem key={item._id} value={item.superAdminRoleId} >{item.superAdminRoleName}</MenuItem>
                ))}
              </Select>
            </FormControl>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <LoadingButton loading={isLoading} type='submit' color='inherit'>{action === 'CREATE' ? "Create" : "Update"}</LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  )
}
